import { environment } from './../../../../../environments/environment';
import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../../../../service/events/dashboard.service';
import { Router } from '@angular/router';
import { FincasApiService } from '../../../../service/api/fincas-api.service';
import { RequestHandler } from '../../../../service/OffService/request-handler';
import {
    FilteredValuesInterface,
    InputType,
    ItemInterface
} from '../../../../common/components/form-builder/form-builder.component';
import { BaseView } from '../../../base-view';
import { build, list, stack } from '../../../../common/classes/request-builder';
import { Filtering } from '../../../../service/filtering/filtering';
import { FormCommonApiService } from '../../../../service/api/formcommon-api.service';
import { RequestButtonTypes } from '../../../../common/components/request-button/request-button.component';
import { StorageManager } from '../../../../common/storage-manager.class';
import { FileSelectEvent, FileUploadEvent, FileUploadModule } from 'primeng/fileupload';
import { UploadResponse, Utils } from '../../../../common/utils';
import { FincasService } from '../../../../service/fincas/fincas.service';
import { createCsv } from 'src/app/common/createCsv';
import { ColInterface } from 'src/app/common/components/common-list-table/col.interface';
import { ColStylesInterface } from 'src/app/common/components/common-list-table/col-styles.interface';
import { FincasModel } from 'src/app/models/form-common/fincas.module';
import { SectorModel } from 'src/app/models/form-common/sector.model';
import { ParcelasModel } from 'src/app/models/form-common/parcelas.model';
import { VisitasVariedadMesModel } from 'src/app/models/visitas_variedad_mes/visitas_variedad_mes.model';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { catchError, firstValueFrom, of, tap, throwError } from 'rxjs';
import { MessageService, TreeNode } from 'primeng/api';

@Component({
    selector: 'app-finca',
    standalone: false,
    templateUrl: './finca.component.html',
    styleUrls: ['./finca.component.scss']
})
export class FincaComponent extends BaseView<FincasModel> implements OnInit {

    public appName = environment.appName;

    public activateREA = environment.features.activateREA;

    public applicationType = environment.features.applicationType;

    public serverUrl = environment.serverUrl;

    public rol: string = StorageManager.getUser().rol;

    public hasClients = environment.features.hasClients;

    public userCanSeeClientes = this.hasClients &&
        (environment.features.userCanSeeClientes ? true : (this.rol === 'admin'));

    public clienteName = environment.features.clienteName;

    public fincaName = environment.features.fincaName;

    public hasPlantas = environment.features.hasPlantas;

    public activateSIEX = environment.features.activateSIEX;

    public showNumeroFincas = environment.features.showNumeroFincas;

    public fincasName = environment.features.fincasName;

    public sectorName = environment.features.sectorName;

    public showCargaPAC = environment.features.showCargaPAC;

    public showCuadernoDeCampo = environment.features.showCuadernoDeCampo;

    public cuadernoOnlyByYear = environment.features.cuadernoOnlyByYear;

    public showCuadernoPorSector = environment.features.showCuadernoPorSector;

    public showClientesCooperativa = environment.features.showClientesCooperativa;

    public showFincasRazonSocial = environment.features.showFincasRazonSocial;

    public showTipoExplotacion = environment.features.showTipoExplotacion;

    public showFincasCodigo = environment.features.showFincasCodigo;

    public showFincasInformeTratamientos = environment.features.showFincasInformeTratamientos;

    public showFincasLibroFertilizantes = environment.features.showFincasLibroFertilizantes;

    public showFincasGenGml = environment.features.showFincasGenGml;

    public showTareasMto = environment.features.showTareasMto;

    public showFincasCsv = environment.features.showFincasCSV;

    public FileUpload: FileUploadModule = new FileUploadModule();

    public getRequest: RequestHandler<FincasModel[]> = this.fincasApi.fincasGET;

    public deleteRequest: RequestHandler<FincasModel> = this.fincasApi.fincasDELETE;

    public deleteRequestButtonType: RequestButtonTypes = RequestButtonTypes.DELETE;

    public canDuplicateFinca = environment.features.canDuplicateFinca;

    public menuItemId = 'finca';

    public filter: Filtering<FincasModel> = new Filtering<FincasModel>();

    public sectores = list();

    public parcelas = list();

    public variedades = list();

    showDialogExportREA = false;

    showSpinner = false;

    messageState = '';

    importResult: any;

    historicoREA: any;


    /* lista de años por defecto */
    public year = list();

    public deleteWarningMessage = '';

    public deleteWarning = '';

    public parcelasAux = true;

    public showModalPAC = false;

    public showPACError = true;

    public txtPACError = '';

    public txtPACInfo = '';

    public fincaPAC = '';

    public urlUpload = '';

    public enableUpload = true;

    public cuadernoColumns = 3;

    public cueHistory: any[] = [];

    public statusCue: any;

    public generarFields: ItemInterface<object>[] = [
        {
            field: 'id_sector',
            label: this.sectorName,
            placeholder: 'TODOS',
            inputType: { type: InputType.DROPDOWN },
            values: this.sectores,
            valuePrimaryKey: 'id',
            filter: (sector: FilteredValuesInterface<SectorModel>) =>
                sector.value?.id_finca === (this.model as TreeNode<FincasModel>).data?.id
        },
        {
            field: 'id_variedad',
            label: 'Variedad',
            placeholder: 'TODAS',
            inputType: {
                type: this.appName === 'covidai' ? InputType.MULTISELECT : InputType.DROPDOWN
            },
            values: this.parcelas,
            multiSelect: this.appName === 'covidai',
            valuePrimaryKey: 'id',
            filter: (it: FilteredValuesInterface<ParcelasModel>) => {
                const cond1 = this.sectores.selected ? (it.value?.id_sector === this.sectores.selected.id) : true;
                const cond2 = it.value?.id_finca === (this.model as TreeNode<FincasModel>).data?.id;

                this.parcelasAux = cond1;

                return cond1 && cond2;
            }
        },
        {
            field: 'fecha_inicio',
            label: 'Fecha inicio',
            inputType: { type: InputType.CALENDAR }
        },
        {
            field: 'fecha_fin',
            label: 'Fecha fin',
            inputType: { type: InputType.CALENDAR }
        }
    ];

    public formFields: ItemInterface<object>[] = [
        {
            field: 'cliente_nombre',
            name: 'Cliente',
            label: 'Cliente',
            inputType: { type: InputType.TEXT },
            visible: this.hasClients
        },
        {
            field: 'razon_social',
            name: 'Razón Social',
            label: 'Razón social',
            inputType: { type: InputType.TEXT },
            visible: this.showFincasRazonSocial
        },
        {
            field: 'nombre',
            name: 'Nombre de' + this.fincaName.toLowerCase(),
            label: 'Nombre de ' + this.fincaName.toLowerCase(),
            inputType: { type: InputType.TEXT }
        },
        {
            field: 'nif',
            name: 'NIF',
            label: 'NIF',
            inputType: { type: InputType.TEXT }
        },
        {
            field: 'codigo',
            name: 'Código',
            label: 'Código',
            inputType: { type: InputType.TEXT },
            visible: this.showFincasCodigo
        },
        {
            field: 'registro_nacional',
            name: 'Registro Nacional',
            label: 'Registro Nacional',
            inputType: { type: InputType.TEXT },
            visible: this.appName !== 'gardengest'
        },
        {
            field: 'registro_autonomico',
            name: 'Registro Autonómico',
            label: 'Registro Autonómico',
            inputType: { type: InputType.TEXT },
            visible: this.appName !== 'gardengest'
        },
        {
            field: 'direccion',
            name: 'Dirección',
            label: 'Dirección',
            inputType: { type: InputType.TEXT }
        },
        {
            field: 'localidad',
            name: 'Localidad',
            label: 'Localidad',
            inputType: { type: InputType.TEXT }
        },
        {
            field: 'codigo_postal',
            name: 'Código Postal',
            label: 'Código Postal',
            inputType: { type: InputType.TEXT }
        },
        {
            field: 'provincia',
            name: 'Provincia',
            label: 'Provincia',
            inputType: { type: InputType.TEXT }
        },
        {
            field: 'telefono',
            name: 'Teléfono',
            label: 'Teléfono',
            inputType: { type: InputType.TEXT }
        },
        {
            field: 'movil',
            name: 'Móvil',
            label: 'Móvil',
            inputType: { type: InputType.TEXT }
        },
        {
            field: 'email',
            name: 'Email',
            label: 'Email',
            inputType: { type: InputType.TEXT }
        },
        {
            field: 'lectura_contador',
            name: 'Acumulado m3',
            label: 'Acumulado m3',
            inputType: { type: InputType.TEXT },
            visible: this.appName === 'abonosfolques'
        },
        {
            field: 'superficie',
            name: 'Superficie',
            label: 'Superficie',
            inputType: { type: InputType.TEXT }
        },

        {
            field: 'tipo_explotacion',
            name: 'Tipo de Explotación',
            label: 'Tipo de explotación',
            inputType: { type: InputType.TEXT },
            visible: this.showTipoExplotacion,
            transform: [
                this.changeTipoExplotacion.bind(this)
            ]
        },
        {
            field: 'alquilado',
            name: 'Alquilado',
            label: 'Alquilado',
            inputType: { type: InputType.RO_SWITCH },
            visible: this.appName === 'covidai' ? true : false
        },
        {
            field: 'observaciones',
            name: 'Observaciones Cliente',
            label: 'Observaciones Cliente',
            inputType: { type: InputType.TEXTAREA },
            visible: this.appName === 'gardengest'
        },
        {
            field: 'propiedad',
            name: 'Propiedad',
            label: 'Propiedad',
            inputType: { type: InputType.TEXT },
            visible: this.appName === 'agropecuariaramirogruas'
        },
        {
            field: 'ccc',
            name: 'CCC',
            label: 'CCC',
            inputType: { type: InputType.TEXT },
            visible: this.appName === 'campanaragricola'
        }
    ];

    public formFieldsTitular: ItemInterface<object>[] = [
        {
            field: 'titular_nombre',
            name: 'Titular Nombre',
            label: 'Titular Nombre',
            inputType: { type: InputType.EDIT_TEXT }
        },
        {
            field: 'titular_nif',
            name: 'Titular NIF',
            label: 'Titular NIF',
            inputType: { type: InputType.EDIT_TEXT }
        },
        {
            field: 'titular_direccion',
            name: 'Titular Dirección',
            label: 'Titular Dirección',
            inputType: { type: InputType.EDIT_TEXT }
        },
        {
            field: 'titular_localidad',
            name: 'Titular Localidad',
            label: 'Titular Localidad',
            inputType: { type: InputType.EDIT_TEXT }
        },
        {
            field: 'titular_codigo_postal',
            name: 'Titular Código Postal',
            label: 'Titular Código Postal',
            inputType: { type: InputType.EDIT_TEXT }
        },
        {
            field: 'titular_provincia',
            name: 'Titular Provincia',
            label: 'Titular Provincia',
            inputType: { type: InputType.EDIT_TEXT }
        },
        {
            field: 'titular_telefono',
            name: 'Titular Teléfono',
            label: 'Titular Teléfono',
            inputType: { type: InputType.EDIT_TEXT }
        },
        {
            field: 'titular_email',
            name: 'Titular Email',
            label: 'Titular Email',
            inputType: { type: InputType.EDIT_TEXT }
        },
        {
            field: 'titular_tipo',
            name: 'Tipo Representación',
            label: 'Tipo Representación',
            inputType: { type: InputType.EDIT_TEXT }
        },
    ];

    public cols: ColInterface[] = [
        {
            field: 'id',
            header: 'Nº Finca',
            filter: '',
            width: '140px',
            visible: this.showNumeroFincas
        },
        {
            field: 'cliente_nombre',
            header: this.clienteName,
            filter: '',
            width: '200px',
            visible: this.hasClients
        },
        {
            field: 'nombre',
            header: 'Nombre ' + this.fincaName,
            filter: '',
            width: '200px'
        },
        {
            field: 'provincia',
            header: 'Provincia',
            filter: ''
        },
        {
            field: 'titular_nombre',
            header: 'Titular',
            filter: '',
            visible: this.appName !== 'gardengest'
        },
        {
            field: 'telefono',
            header: 'Teléfono',
            filter: ''
        },
        {
            field: 'email',
            header: 'Email',
            filter: '',
            width: '150px'
        },
        {
            field: 'lectura_contador',
            header: 'Acumulado m3 ',
            visible: this.appName === 'abonosfolques'
        },
        {
            field: 'cooperativa',
            header: 'Cooperativa',
            filter: '',
            width: '150px',
            visible: this.showClientesCooperativa
        }
    ];

    public user = StorageManager.getUser();

    public canAddFincas = environment.features.canAddFincas;

    public canEditFincas = environment.features.canEditFincas;

    public canDeleteFincas = environment.features.canDeleteFincas;

    private readonly currentDate = new Date();

    private readonly currentYear: number = this.currentDate.getFullYear();

    private readonly yearsToShow = this.currentYear - 2016;



    constructor(
        private readonly fincasApi: FincasApiService,
        private readonly _fincasService: FincasService,
        private readonly formApi: FormCommonApiService,
        public dashboard: DashboardService,
        public messageService: MessageService,
        private readonly router: Router,
        private readonly http: HttpClient
    ) {
        super(dashboard, fincasApi.fincasGET, fincasApi.fincasDELETE);

    }


    ngOnInit() {
        this.dashboard.setSubmenuItem(this.menuItemId);

        stack([
            build(this.fincasApi.sectoresGET, this.sectores, 'nombre', true),
            build(
                this.fincasApi.parcelasGET,
                this.parcelas,
                ((it: VisitasVariedadMesModel) => ((
                    ((this.hasPlantas || !this.activateSIEX) ?
                        it.variedad_legacy :
                        it.variedad
                    ) || 'Sin variedad')) + ' (' + ((this.hasPlantas || !this.activateSIEX) ? it.cultivo_legacy : it.cultivo) + ')'),
                true),
            build(this.formApi.variedadesGET, this.variedades, 'variedad', true),
        ]).then(() => {
            this.filterVariedades();
            this.filter.filter();
            return;
        }).catch(e => {
            console.log('catch en getPosition: ' + e);
        }
        );

        this.filter.addFilter((data: TreeNode<FincasModel>[] | void) =>
            (data || []).filter((finca: TreeNode<FincasModel>) => finca));
    }

    getLastRegisterREA(): void {

        if (this.activateREA) {
            this.http.get(`${environment.serverUrl}/ws/index.php?p1=fincas&p2=getLastRegisterREA&codigo_REA=${this.model.codigo_REA}`)
                .subscribe(res => {
                    this.historicoREA = res;
                });
        }
    }

    async exportREA(data: FincasModel): Promise<void> {
        const usuario = StorageManager.getUser().id;

        const url = `${environment.serverUrl}/ws/index.php?p1=fincas&p2=exportarREA`;

        try {

            if (data.id_cliente && data.codigo_REA && data.nif) {

                let response = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    body: new URLSearchParams({
                        id_finca: data.id ?? '',
                        nombre_finca: data.nombre,
                        id_usuario: usuario,
                        id_cliente: data.id_cliente,
                        codigo_REA: data.codigo_REA,
                        nif: data.nif,
                        tipoFormulario: 1
                    } as
                        { id_finca: string, nombre_finca: string, id_usuario: string, id_cliente: string, codigo_REA: string, nif: string })
                }) as any;

                response = await response.json();

                if (response.statusCode === 202) {
                    this.messageState = 'sucess';
                    this.importResult = response;
                    this.showSpinner = false;

                } else if (response.statusCode === 422) {
                    this.messageState = 'error';
                    this.importResult = { ...response, statusMessage: response.data.errores[0].descripcion };
                    this.showSpinner = false;
                } else if (response.statusCode === 500) {
                    this.messageState = 'error';
                    this.importResult = response;
                    this.showSpinner = false;
                }

            } else {
                this.messageState = 'warning';
                this.showSpinner = false;
            }

        } catch (error) {
            this.importResult = { statusCode: 0, statusMessage: 'Error al importar REA', data: [] };
            this.messageState = 'error';
            this.showSpinner = false;

            console.error('💥 Error al importar REA => ', error);
        }
    }

    checkStatusCUE(data: FincasModel): void {
        this.http.post<any[]>(`${environment.serverUrl}/ws/index.php?p1=fincas&p2=checkCUE`, { id_finca: data.id }).subscribe(res => {
            this.cueHistory = res;
            this.statusCue = this.cueHistory.at(0);
        });
    }

    getStatusCUE(data: FincasModel): void {
        this.checkStatusCUE(data);
    }

    exportCUE(data: FincasModel): any {

        // const usuario = StorageManager.getUser().id;
        const url = `${environment.serverUrl}/ws/index.php?p1=fincas&p2=sendCUE`;

        try {
            if ((data.id_cliente != null) && (data.codigo_REA != null) && (data.nif != null) && (data.comunidad_autonoma_INE != null)) {
                const params = new HttpParams().set('id_finca', data.id)
                    .set('comunidad_autonoma_ine', data.comunidad_autonoma_INE)
                    .set('nif', data.nif)
                    .set('codigo_REA', data.codigo_REA);

                this.http.get(url, { params, observe: 'response' }).pipe(
                    tap(response => {
                        if (response.status === 204) {
                            console.log('Response is 204 No Content');
                            this.messageState = 'success';
                            this.importResult = {
                                statusCode: response.status,
                                statusMessage: 'No Content',
                                data: [{
                                    body: 'La finca no tienes los datos suficientes para enviar el CUE.'
                                }]
                            };
                            this.showSpinner = false;
                             
                        }

                    }),
                    catchError(error => {

                        if (error.status === 409) {
                            console.log('Response is 409 Conflict');
                            this.messageState = 'error';
                            this.importResult = {
                                statusCode: 409,
                                statusMessage: 'Conflict',
                                data: [{
                                    body: error.error.data.descripcion + '. Contacta con el administrador.'
                                    // body: 'El CUE ya se ha enviado anteriormente. Por favor, revise los registros.'
                                }]
                            };
                            this.showSpinner = false;
                            // console.log('Error occurred:', error);;
                            return of();
                        }

                        if (error.status === 500) {
                            this.messageState = 'error';
                            this.importResult = {
                                statusCode: 500,
                                statusMessage: 'Servicio no disponible. Contacta con el administrador.',
                                data: [{
                                    body: error.error.data.descripcion + '. Contacta con el administrador.'
                                }]
                            };
                            this.showSpinner = false;
                        }

                        console.log('Error occurred:', error);
                        return throwError(error);
                    })
                ).subscribe({
                    next: async (res: any) => {
                        console.log('respuesta del cue', res);

                        const resultado = res.resultado;

                        if (resultado.codigoResultado === 'FALLO') {
                            this.messageState = 'sucess';
                            this.importResult = {
                                statusCode: 200,
                                statusMessage: 'OK',
                                data: [{
                                    body: 'Fallo al enviar el CUE. Contacta con la empresa desarrolladora.'
                                }]
                            };
                            this.showSpinner = false;
                            console.error('💥 Fallo en la formacion del json => ', resultado.detalleImportacion);
                        }

                        if (resultado.codigoResultado === 'OK') {
                            this.messageState = 'sucess';
                            this.importResult = {
                                statusCode: 200,
                                statusMessage: 'OK',
                                data: [{
                                    body: 'El CUE se ha enviado correctamente.'
                                }]
                            };
                            this.showSpinner = false;

                            let continueRequest = true;

                            while (continueRequest) {
                                const checkParams = new HttpParams().set('id_finca', data.id);

                                await new Promise(resolve => setTimeout(resolve, 5000));
                                const loopResponse = await firstValueFrom<any>(this.http.get(url, { params: checkParams }));

                                if (loopResponse.someCondition) {
                                    continueRequest = false;
                                }
                            }
                        }
                    }
                });
            } else {
                this.importResult = {
                    statusCode: 0, 
                    statusMessage: 'Falta datos para enviar CUE', 
                    data: [{
                            body: 'Comprueba los datos del formulario y vuelve a intentarlo. Datos obligatorios:' +
                                'Comunidad autónoma, NIF, Código REA'
                    }]
                };
                this.messageState = 'error';
                this.showSpinner = false;

            }

        } catch (error) {
            this.importResult = { statusCode: 0, statusMessage: 'Fallo en el envío del CUE', data: [] };

            this.messageState = 'error';
            this.showSpinner = false;

            console.error('💥 Fallo en la petición => ', error);
        }
    }

    public override show(modal: string, data: any): void {
        let x;

        this.model = data;
        this.canShow[modal] = true;

        if (modal === 'importREA') {
            this.getLastRegisterREA();
        }

        if (modal === 'sendCUE') {
            this.checkStatusCUE(data);
        }

        for (x in this.canShow) {
            if (x !== modal && this.canShow[x]) {
                this.canShow[x] = false;
            }
        }
    }

    public override hide(modal: string): void {
        this.model = {} as any;
        this.canShow[modal] = false;
        if (this._deleteRequest) {
            this._deleteRequest.reset();
        }
    }

    public changeTipoExplotacion(model: ItemInterface<object>): any {

        const tipos = list(
            ['...', null],
            ['Agricultura Ecológica', 'AE'],
            ['Producción Integrada', 'PI'],
            ['Certificacion Privada', 'CP'],
            ['Agrupacion de Tratamiento Integrado en Agricultura', 'Atrias'],
            ['Asistida de un asesor', 'AS'],
            ['Sin obligacion de aplicar la GIP', 'NO']
        );

        try {
            if (model['tipo_explotacion'] == null) {
                return model;
            }
            const tipoExplotacion = tipos.filtered.find(tipo => {
                if ((model['tipo_explotacion'] as string).localeCompare(tipo.value) === 0) {
                    return tipo;
                }
            });

            model['tipo_explotacion'] = tipoExplotacion.label;
            return model;
        } catch (error) {
            console.log(error);
            return model;
        }
    }

    public filterSectores(): void {
        this.sectores.selected = null;
        this.parcelas.selected = null;
        this.variedades.selected = null;
    }

    public filterVariedades(): any {
        const idx = [];
        const repes: string[] = [];

        this.parcelas.values = this.parcelas.values.map(it => {
            if (it.value && !repes.includes(it.label + '_' + it.value.id_finca + '_' + it.value.id_sector)) {
                repes.push(it.label + '_' + it.value.id_finca + '_' + it.value.id_sector);
                idx.push(it);
                return it;
            }
            return null;
        }).filter(it => it);
    }

    public add(): void {
        if (!StorageManager.getClient() && this.userCanSeeClientes) {
            this.dashboard.openClientDialog();
        } else {
            this.router.navigate(['dashboard', 'crear-finca']);
        }
    }

    public edit(data: FincasModel): void {
        this.router.navigate(['dashboard', 'editar-finca', data.id, data]);
    }

    public duplicate(data: FincasModel): void {
        this.router.navigate(['dashboard', 'duplicar-finca', data.id]);
    }

    public override deleteRegister(): void {
        if (this.model.id) {
            if (this.deleteWarning) {
                this.deleteWarning = '';
                this.deleteWarningMessage = '';

                this.deleteRequest.safePerform(this.model);
                this.deleteRequest.response(() => {
                    if (!this.deleteRequest.hasError) {
                        this.getRequest.safePerform();
                    }
                });
            } else {
                this.deleteWarningMessage =
                    'Se borrará toda la información asociada';
                this.deleteWarning = '¡' + this.fincaName + ' con datos! ¿Continuar?';
            }
        } else {
            this.deleteRequest.hasError = true;
            throw new Error('Trying to DELETE a register without primary key');
        }
    }


    public globalVisualTransform(value: string): string {
        return value;
    }

    public globalConditionalStyle(value: string | number, col: ColInterface): ColStylesInterface {
        if (col.field === 'lectura_contador' && +value >= 6000) {
            return {
                textAlign: 'center',
                marginRight: '60px',
                color: 'red'
            };
        }
        if (Utils.isNumber(value?.toString() ?? '') || col.field === 'telefono') {
            return {
                textAlign: 'center',
                marginRight: '60px'
            };
        }
        if (col.field === 'provincia' || col.field === 'titular_nombre') {
            return {
                textAlign: 'center'
            };
        }
        return {};
    }


    ////////////////////////////////////////////////////////////
    ////     SUBE ARCHIVIO PAC Y CREA/ACTUALIZA PARCELAS    ////
    ////////////////////////////////////////////////////////////
    checkFile(event: FileSelectEvent): void {
        this.showPACError = false;
        const file = event.files[0]?.name ?? '';

        if (!file.includes('.xlsx') && !file.includes('.xls')) {
            this.showPACError = true;
            this.txtPACError = 'El archivo debe ser un Excel(xlsx)';
        }
    }

    uploadDialog(data: FincasModel): void {
        this.showModalPAC = true;
        this.fincaPAC = data.id;
        this.urlUpload = environment.serverUrl +
            'ws/informes/excel_pac/fileUploadData.php?id_finca=' +
            data.id +
            '&id_cliente=' +
            data.id_cliente +
            '&id_usuario=' +
            data.id_usuario;
    }


    uploaded(event: FileUploadEvent): void {
        if (event.originalEvent instanceof HttpResponse) {
            const response: UploadResponse = event.originalEvent.body;

            if (response) {
                const parcelasFound = response.content_found;
                const parcelasNotFound = response.content_not_found;
                const especiesFound = response.especie_found;
                const especiesNotFound = response.especie_not_found;

                const arrayEspeciesFound = [];
                const arrayEspeciesNotFound: number[] = [];
                const arrayParcelasFound: string[] = [];
                const arrayParcelasNotFound: string | string[] = [];

                especiesFound.forEach((it: string) => {
                    arrayEspeciesFound.push(it);
                });
                especiesNotFound.forEach((it: number) => {
                    arrayEspeciesNotFound.push(it);
                });
                parcelasFound.forEach((it: ParcelasModel) => {
                    arrayParcelasFound.push(it.numero ?? '');
                });
                parcelasNotFound.forEach((it: ParcelasModel) => {
                    arrayParcelasNotFound.push(it.numero ?? '');
                });

                this.showPACError = true;
                this.txtPACInfo = 'Carga de las Parcelas realizada correctamente<br />';
                this.txtPACInfo += arrayParcelasNotFound;
                this.txtPACInfo += '<br>';

                this.txtPACInfo += 'Parcelas actualizadas<br />';
                this.txtPACInfo += arrayParcelasFound;
                this.txtPACInfo += '<br/>';
                this.txtPACInfo += '<br/>';

                if (!arrayEspeciesNotFound.length) {
                    this.txtPACInfo += '¡Todos los Especies/Cultivos han sido encontrados! <br />';
                } else {
                    this.txtPACError = '¡Especies/Cultivos no encontrados! <br />';
                    this.txtPACError += this.unique(arrayEspeciesNotFound);
                }
            }
        }
    }

    closeFUDialog(): void {
        this.showModalPAC = false;
        this.showPACError = false;
        location.reload();
    }

    unique(array: number[]): number[] {
        return array.filter((a: number) => !array[a] ? true : false, {});
    }



    /* Generamos la lista de años desde el 2016 hasta el año actual */
    public generateYearList(): void {
        this.year.filtered[0] = { 'label': 'Seleccione un año', 'value': null };
        for (let i = this.yearsToShow; i >= 0; i--) {
            this.year.filtered.push({ 'label': this.currentYear - i, 'value': this.currentYear - i });
        }
    }

    // PETICIÓN GET PARA GENERAR CUADERNO 
    public generarCuaderno(informe_tratamientos = false, libro_fertilizantes = false): void {
        if (!this.model.fecha_inicio || !this.model.fecha_fin) {
            alert('Debe especificar un intervalo de fechas.');
            return;
        }

        const modelTree = this.model as unknown as TreeNode<FincasModel>;

        if (!modelTree.data) {
            console.error('El modelo no contiene datos en la propiedad "data".');
            return;
        }

        const finca = modelTree.data.nombre;
        const idFinca = modelTree.data.id;
        const idCliente = modelTree.data.id_cliente;
        const appName = this.appName;
        const idSectores = (this.sectores.selected == null) ? '' : this.sectores.selected.id;
        let idVariedad = '';
        const user = this.user.id;

        if (this.appName === 'covidai') {
            this.parcelas.selected.forEach((parcela: ParcelasModel) => {
                idVariedad += parcela.id_variedad + ',';
            });
            idVariedad = idVariedad.slice(0, -1);
        } else {

            if (this.parcelas.selected != null) {
                if (this.parcelas.selected.id_variedad != null) {
                    idVariedad = this.parcelas.selected.id_variedad;
                } else {
                    idVariedad = this.parcelas.selected.id_variedad_legacy;
                }
            } else {
                idVariedad = '';
            }
        }

        let cuadernoFields = '?finca=' + finca +
            '&id_finca=' + idFinca +
            '&id_sector=' + idSectores +
            '&id_cliente=' + idCliente +
            '&app_name=' + appName +
            '&id_variedad=' + idVariedad +
            '&id_user=' + user;

        const interval: { fechaInicio: string, fechaFin: string, anyo: string } =
            this.getDates(this.model.fecha_inicio, this.model.fecha_fin);
        const fechaFin = interval.fechaFin;
        const fechaInicio = interval.fechaInicio;
        const anyo2 = interval.anyo;

        cuadernoFields += '&fecha_fin=' + fechaFin +
            '&fecha_inicio=' + fechaInicio + '&anyo=' + anyo2;

        if (informe_tratamientos) {
            cuadernoFields += '&informe_tratamientos=true';
        }
        if (libro_fertilizantes) {
            cuadernoFields += '&libro_fertilizantes=true';
        }
        window.open((this.serverUrl + 'ws/informes/index.php' + cuadernoFields), '_blank');
    }

    public formChanges(): void {
    }

    public generaGML(data: ParcelasModel): void {

        firstValueFrom(this._fincasService.verificaGML(data.id))
            .then((resp) => {
                if (resp.success) { this._fincasService.generaGML(data.id); }
                else { alert(resp.mensaje); }
                return;
            })
            .catch(error => {
                console.log('error', error);
            });

    }

    public downloadCsv(): void {

        const arrayFormFields = [
            this.formFields,
            this.formFieldsTitular
        ];

        const csvContent = createCsv(arrayFormFields, this.filter.value, 'titular_tipo');

        const csvLink = document.getElementById('csvLink') as HTMLAnchorElement;

        csvLink.download = 'Fincas.csv';
        csvLink.href = encodeURI(csvContent);
        csvLink.click();
    }

    public getDates(inicio: string | Date, fin: string | Date): { fechaInicio: string, fechaFin: string, anyo: string } {
        const fechaInicio = (inicio instanceof Date) ? Utils.formatDate(inicio) : inicio;
        const fechaFin = (fin instanceof Date) ? Utils.formatDate(fin) : fin;

        // Si no hay año se calcula con los años de la fecha de inicio y de fin (2017-2018)
        let anyo = fechaInicio.split('/')[2] ?? '';

        anyo = fechaInicio.split('/')[2] + '-' + fechaFin.split('/')[2];
        if (fechaInicio.split('/')[2] === fechaFin.split('/')[2]) { anyo = fechaInicio.split('/')[2] ?? ''; }

        return { fechaInicio, fechaFin, anyo };
    }
}
